import { IPermission, PermissionAccessRole, PermissionLevel, Scope } from "@interfaces/fc-user/permissions";
import { getDefaultPermissionsScope } from "@services/fc-user/permissions";

export const mergeUserRolesGlobal = async (roles:string[], scope:Scope) => {
    if(roles.length > 0){
        try {
            const totalRoles1 :IPermission[] = [];
            const rolesData2 = roles.map(async (role) => {
                const permission = await getDefaultPermissionsScope(role as PermissionAccessRole, scope)
                permission.access.forEach((role)=>{
                    const index = totalRoles1.findIndex(r => r.permission === role.permission)
                    if (index < 0) {
                        totalRoles1.push(role);
                    } else {
                        totalRoles1[index] = role;
                    }
                })
                return permission
            })
            await Promise.all(rolesData2)
            return totalRoles1
        } catch (error) {
            return []
        }
    }else{
        return []
    }
}
export const validAllCheckPermisision =(permissions:IPermission[]) =>{
    let countWrite = 0;  
    let countNone = 0;
    permissions.forEach((p)=>{
        if(p.level === 'none'){
            countNone ++
        }else{
            countWrite ++
        }
    })
    const data = {
        countWrite:countWrite,
        countNone: countNone
    }
    return data
}
export const updatePermissionsLevelStatus =(permissions:IPermission[], newPermissions: IPermission[]) =>{
    const permissionsReturn = permissions.map( p =>{
        const newPermission = newPermissions.find(np => np.permission === p.permission)
        const returnPermission = newPermission ?? p
        returnPermission.level = PermissionLevel[newPermission ? "WRITE" : "NONE"]
        return returnPermission
    })
    return permissionsReturn
}